import type { AnalytixSendMethods, AnalytixUserInfo } from './index.h'
import type { ANALYTIX_EVENT_PARAM_NAMES } from './lib'

import { createEvent, sample } from 'effector'
import { ANALYTIX_EVENT_NAMES } from './lib'

export const send = createEvent<{
  name: keyof AnalytixSendMethods
  params: Parameters<AnalytixSendMethods[keyof AnalytixSendMethods]>[0]
  general: AnalytixUserInfo
}>()

type UnionToIntersection<U> = (U extends any ? (x: U) => void : never) extends (
  x: infer I
) => void
  ? I
  : never

type MergedParams = UnionToIntersection<
  Exclude<
    Parameters<AnalytixSendMethods[keyof AnalytixSendMethods]>[0],
    undefined
  >
>

export const sent = createEvent<
  AnalytixUserInfo &
    MergedParams & {
      eventName: keyof typeof ANALYTIX_EVENT_PARAM_NAMES
    }
>()

sample({
  clock: send,
  fn({ name, params, general }) {
    const eventName = ANALYTIX_EVENT_NAMES[name]
    return {
      eventName: eventName,
      ...general,
      ...params,
    }
  },
  target: sent,
})
